import { lazy } from "react"
import { RouteProps } from "../features.types"

const PaymentsController = lazy(() => import("./payments-controller"))
const PaymentsHome = lazy(() => import("./payments"))
// define route constant
export const PAYMENTS_ROUTE = "payments"
export const VERIFY_PAYMENT_ROUTE = "payments/verify-payment"

//define routes
export const Payments: RouteProps[] = [
  {
    path: `${PAYMENTS_ROUTE}`,
    Component: PaymentsController,
    children: [
      {
        index: true,
        Component: PaymentsHome,
      },
    ],
  },
]
